import { lazy } from "react";

const multiCreate = lazy(() => import("./MultiCreate").then(m => ({ default: m.DocumentCreate })));

export default { multiCreate };
